import { Component, OnInit } from '@angular/core';
import { ProductPayloadService } from '../product-payload.service';
import { Observable, of } from 'rxjs';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-product-payload-progress',
  templateUrl: './product-payload-progress.component.html',
  styleUrls: ['./product-payload-progress.component.scss'],
})
export class ProductPayloadProgressComponent implements OnInit {
  uploadProgress$: Observable<number> = of(0);

  constructor(
    private readonly productPayloadService: ProductPayloadService,
    public dialogRef: MatDialogRef<ProductPayloadProgressComponent>
  ) {}

  ngOnInit(): void {
    this.uploadProgress$ = this.productPayloadService.getUploadProgress();
  }
}
